//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HowSection',
  data() {
    return {
      isVideoActive: false,
    }
  },
  computed: {
    isUnity() {
      return this.$route.path.split('/').pop() === 'unity'
    },
    isFrontend() {
      return this.$route.path.split('/').pop() === 'frontend'
    },
  },
  methods: {
    fixProjectPicture(projectPicUrl) {
      const url = this.projectPicture(projectPicUrl)
      return 'background-image: url("' + url + '")'
    },
    startVideo() {
      this.isVideoActive = true
    },
    projectPicture(url) {
      if (url) {
        return url
      }

      return require('@/assets/img/redesign/pc/how-slide-01.png')
    },
  },
}
